import React from 'react';
import './App.css';

export default function Header() {
    return (
        <header> 
        <h2 class='title' id="navbar"> d. web dev </h2>
        </header> );
    }
